import { render } from "./GenresPage.vue?vue&type=template&id=0c42b0ff"
import script from "./GenresPage.vue?vue&type=script&lang=js"
export * from "./GenresPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__